import { render, staticRenderFns } from "./companyInfo.vue?vue&type=template&id=0af1a4e1&scoped=true&"
import script from "./companyInfo.vue?vue&type=script&lang=js&"
export * from "./companyInfo.vue?vue&type=script&lang=js&"
import style0 from "./companyInfo.vue?vue&type=style&index=0&id=0af1a4e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af1a4e1",
  null
  
)

export default component.exports